export const FIRESTORE_ACCOUNTS_COLLECTION = "accounts";